/**
 * A sequence of phases or moves as proportional segments (SNIPPETS §16): past brand, the current
 * one brand-soft with a brand fill at its progress, future track. On a player (`onSurface`) past
 * is --on-surface and the rest --on-surface-track, so nothing inverts with the theme.
 *
 * When to use: player progress, the treadmill protocol. It is `aria-hidden` — pair it with a
 * 13.8 muted line that says the same thing in words ("Brisk 2 of 3 · 1:12 left").
 */
export function SegmentBar({
  count,
  current,
  progress = 0,
  weights,
  onSurface,
}: {
  count: number;
  /** index of the current segment; `count` or more means all done, below 0 none started */
  current: number;
  /** 0..1 through the current segment */
  progress?: number;
  /** relative lengths (e.g. durations); equal when omitted */
  weights?: number[];
  onSurface?: boolean;
}) {
  const p = Math.max(0, Math.min(1, progress));
  return (
    <div className={`k-segbar${onSurface ? " k-segbar--on-surface" : ""}`} aria-hidden="true">
      {Array.from({ length: count }, (_, i) => {
        const w = weights?.[i] ?? 1;
        const state = i < current ? "is-past" : i === current ? "is-cur" : "is-future";
        return (
          <span key={i} className={state} style={{ flex: `${w} 1 0` }}>
            {i === current ? <span style={{ width: `${(p * 100).toFixed(1)}%` }} /> : null}
          </span>
        );
      })}
    </div>
  );
}
